import { AxiosResponse } from 'axios';
import api from './api';

export default {
  show(clinicalCareUid: string, id: string): Promise<AxiosResponse> {
    return api.get(`/prescritions/${id}/clinical-care/${clinicalCareUid}`);
  },
};
